import '../assets/stylesheets/settings.css'

export default function Settings() {

    return <h1>Settings page</h1>

}